import { MESSAGE_TEMPLATE_MODEL } from "@/models/message-template-model";
import JSONApiService from "@/services/JSONApiService";
import pluralize from "pluralize";
import APIService from "@/services/APIService";

const organisationMessageTemplateApi = commit => ({
  getAll: params =>
    JSONApiService(commit)
      .all(MESSAGE_TEMPLATE_MODEL)
      .get(params),
  add: data => JSONApiService(commit).create(MESSAGE_TEMPLATE_MODEL, data),
  createMessageTemplateFile: async (id, data) =>
    APIService.client().postFile(
      `${pluralize(MESSAGE_TEMPLATE_MODEL)}/${id}/file`,
      data
    ),
  edit: data =>
    JSONApiService(commit)
      .one(MESSAGE_TEMPLATE_MODEL, data.id)
      .patch(data)
});

export default organisationMessageTemplateApi;
